import Init from '../../../extendable/Init';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Join from '../../../components/Join/Join';

import './Contact.scss';

const Contact = () => {
	const initMap = () => {
		const mapElement = document.getElementById('js-google-map');
		const latMap = mapElement.dataset.lat;
		const lngMap = mapElement.dataset.lng;
		
		
		if (mapElement) {
			const center = { lat: parseFloat(latMap), lng: parseFloat(lngMap) };
			
			const map = new google.maps.Map(mapElement, {
				center,
				zoom: 17,
			});
			new google.maps.Marker({
				position: center,
				map,
				title: 'Inteuro',
				icon: '/images/marker.png',
				anchor: new google.maps.Point(60, 97),
			});
		}
	};
	
	initMap();
};

Init(Contact);

